import React from "react";
import { useMediaQuery } from "react-responsive";
import ArrowButton from "../../components/common/ArrowButton";
import { getPatronatInfoByName } from "../../backend/info/patronatInfo";
import { Helmet } from "react-helmet-async";

const MissionCard = ({ text }) => {
  const isMedium = useMediaQuery({ query: `(max-width: 768px)` });
  const isSmall = useMediaQuery({ query: `(max-width: 450px)` });
  return (
    <div
      style={{
        ...styles.missionCardContainer,
        marginBottom: isSmall ? "1rem" : isMedium ? "2rem" : "3rem",
      }}
    >
      <div
        style={{
          ...styles.bulletPoint,
          marginTop: isSmall ? "0.5rem" : isMedium ? "0.75rem" : "0.875rem",
        }}
      />
      <h3
        style={{
          ...styles.missionCardDescription,
          fontSize: isSmall ? "1.25rem" : isMedium ? "1.5rem" : "2rem",
        }}
      >
        {text}
      </h3>
    </div>
  );
};

const ServiceMission = () => {
  const isLess = useMediaQuery({ query: `(max-width: 1100px)` });
  const isMobile = useMediaQuery({ query: `(max-width: 768px)` });
  const isMedium = useMediaQuery({ query: `(max-width: 500px)` });
  const isSmall = useMediaQuery({ query: `(max-width: 400px)` });

  return (
    <>
      <Helmet>
        <title>210 Окремий Штурмовий Полк | Патронатна Служба</title>
        <meta name="description" content="Служба супроводу військовослужбовців та ЧЛЕНІВ ЇХНІХ СІМЕЙ"/>
      </Helmet>
    <div style={styles.missionWrapper}>
      <div
        style={{
          ...styles.missionContainer,
          paddingTop: isSmall ? "2rem" : isMobile ? "2rem" : "3rem",
          paddingBottom: isSmall ? "3rem" : isMobile ? "4rem" : "5rem",
        }}
      >
        <h2
          style={{
            ...styles.header,
            fontSize: isMobile ? "min(2.5rem, 9vw)" : "3rem",
            marginBottom: isSmall ? "1rem" : isMobile ? "2rem" : "3rem",
          }}
        >
          Основні завдання служби:
        </h2>
        <MissionCard text={getPatronatInfoByName("missionTop")} />
        <MissionCard text={getPatronatInfoByName("missionBottom")} />
        {isMobile && (
          <div
            style={{
              marginTop: isSmall ? "0.5rem" : isMobile ? "1rem" : "2rem",
            }}
          />
        )}
        <ArrowButton
          text="Звернутись до Служби супроводу"
          fontSize={isMobile ? "4.5vw" : isLess ? "2.2rem" : "3rem"}
          external_link={getPatronatInfoByName("feedbackLink")}
          iconColor="var(--olive)"
          iconSize={isSmall ? "2rem" : isMedium ? "3rem" : isMobile ? "4rem" : "6rem"}
          padding={isMobile ? "0.5rem" : "1rem"}
        />
      </div>
    </div>
    </>
  );
};

const styles: Record<string, React.CSSProperties> = {
  missionWrapper: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    backgroundColor: "var(--white)",
  },
  missionContainer: {
    display: "flex",
    flexDirection: "column",
    width: "var(--main-container-width)",
    padding: "2rem 0",
  },
  missionText: {
    fontSize: "1.2rem",
    lineHeight: "1.5",
    color: "var(--dark-grey)",
    margin: "0",
    maxWidth: "80%",
  },
  header: {
    fontSize: "5rem",
    fontWeight: "bold",
    color: "var(--black)",
  },
  missionCardContainer: {
    display: "flex",
    flexDirection: "row",
    gap: "2rem",
  },
  bulletPoint: {
    width: "15px",
    height: "15px",
    marginTop: "0.85rem",
    backgroundColor: "var(--black)",
    flexShrink: 0,
  },
  missionCardDescription: {
    fontSize: "2rem",
    fontWeight:"normal",
    color: "var(--grey)",
  },
};

export default ServiceMission;
